export default [
    {
        path: '/sales/quotation',
        name: 'quotation',
        props: true,
        component: () => import('@/views/sales/quotation/index.vue'),
        meta: {
            pageTitle: 'Quotation',
            breadcrumb: [
                {
                text: 'Quotation',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/quotation/:id',
        name: 'detail-quotation',
        props: true,
        component: () => import('@/views/sales/quotation/detail.vue'),
        meta: {
            pageTitle: 'Detail Quotation',
            breadcrumb: [
                {
                text: 'Quotation',
                to: { name: 'quotation' },
                },
                {
                text: 'Detail Quotation',
                active: true,
                },
            ],
        },
    },
]